/**
 * Auto-refresh mixin for components that need periodic data updates
 * Provides startAutoRefresh() and stopAutoRefresh() methods
 * Automatically cleans up interval on component unmount
 */
export default {
    data() {
        return {
            autoRefreshInterval: null,
        };
    },
    methods: {
        /**
         * Start auto-refresh interval
         * @param {string} action - Vuex action to dispatch
         * @param {number} intervalMs - Interval in milliseconds (default: 30000)
         */
        startAutoRefresh(action, intervalMs = 30000) {
            this.stopAutoRefresh(); // Prevent multiple intervals
            this.autoRefreshInterval = setInterval(() => {
                this.$store.dispatch(action);
            }, intervalMs);
        },
        /**
         * Stop auto-refresh interval
         */
        stopAutoRefresh() {
            if (this.autoRefreshInterval) {
                clearInterval(this.autoRefreshInterval);
                this.autoRefreshInterval = null;
            }
        },
    },
    beforeUnmount() {
        this.stopAutoRefresh();
    },
};
